import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Home", path: "/", active: true },
  { label: "About", path: "/about" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar({ onRegister }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  // const handleRegister = () => {
  //   closeMobileMenu();
  //   onRegister();
  // };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-[#e5e7eb] bg-white">
      <div className="mx-auto flex h-[94px] max-w-[1400px] items-center justify-between px-6">

        {/* Logo */}
        <Link
          to="/"
          className="flex shrink-0 items-center"
          onClick={closeMobileMenu}
        >
          <img
            src="/biznep-mainsite/BizNepLogo.webp"
            alt="BizNep"
            className="h-[62px] w-auto"
          />
        </Link>

        {/* Desktop Navigation */}
        <nav className="ml-16 hidden items-center gap-[42px] md:flex">
          {navLinks.map((link) => (
            <Link
              key={link.label}
              to={link.path}
              className={`relative text-[17px] font-semibold tracking-[-0.01em] text-[#0b4ea2] transition-colors hover:text-[#083b7a] ${
                link.active
                  ? "after:absolute after:-bottom-[12px] after:left-0 after:h-[2px] after:w-full after:bg-[#ef233c]"
                  : ""
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Desktop Authentication Buttons */}
        {/* <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/login"
            className="rounded-[8px] border-2 border-[#c7dcfa] bg-white px-[23px] py-[10px] text-[16px] font-semibold text-[#0b4ea2] transition-colors hover:bg-[#f5f9ff]"
          >
            Sign In
          </Link>

          <button
            type="button"
            onClick={handleRegister}
            className="rounded-[8px] bg-[#ef233c] px-[24px] py-[11px] text-[16px] font-semibold text-white transition-colors hover:bg-[#d91e36]"
          >
            Create Account
          </button>
        </div> */}

        {/* Mobile Hamburger */}
        <button
          type="button"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="flex items-center justify-center rounded-md p-2 text-[#0b4ea2] hover:bg-[#f5f9ff] md:hidden"
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
          aria-expanded={mobileMenuOpen}
        >
          {mobileMenuOpen ? (
            <X size={30} strokeWidth={2.2} />
          ) : (
            <Menu size={30} strokeWidth={2.2} />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="border-t border-[#e5e7eb] bg-white md:hidden">
          <nav className="flex flex-col px-6 py-4">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.path}
                onClick={closeMobileMenu}
                className={`border-b border-[#eef2f7] py-4 text-[16px] font-semibold text-[#0b4ea2] last:border-b-0 ${
                  link.active ? "text-[#ef233c]" : ""
                }`}
              >
                {link.label}
              </Link>
            ))}

            {/* Mobile Authentication Buttons */}
            {/* <div className="flex flex-col gap-3 pt-5">
              <Link
                to="/login"
                onClick={closeMobileMenu}
                className="w-full rounded-[8px] border-2 border-[#c7dcfa] bg-white px-5 py-3 text-center text-[16px] font-semibold text-[#0b4ea2] transition-colors hover:bg-[#f5f9ff]"
              >
                Sign In
              </Link>

              <button
                type="button"
                onClick={handleRegister}
                className="w-full rounded-[8px] bg-[#ef233c] px-5 py-3 text-center text-[16px] font-semibold text-white transition-colors hover:bg-[#d91e36]"
              >
                Create Account
              </button>
            </div> */}
          </nav>
        </div>
      )}
    </header>
  );
}